import { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import CustomInput from "../../../common/CustomInput";
import { validations } from "../../../constants";
import { apiCallV2 } from "../../../utils/api";
import { CallImpactConversion } from "../../../redux/v2/impact/actions";
import { SetUserDetails } from "../../../redux/v2/user/actions";
import { FillEye, FillEyeSlash } from "../../../common/CustomIcons";
import CustomActionButton from "../../../common/CustomActionButton";

const EmailSignupComponent = (props) => {
    const token = new URLSearchParams(window.location.search).get("token");

    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [email, setEmail] = useState("");
    const [emailAddress, setEmailAddress] = useState(""); //h-p
    const [fullName, setFullName] = useState(""); //h-p

    const [error, setErrorMessage] = useState("");
    const [emailError, setEmailErrorMessage] = useState("");
    const [passwordError, setpasswordError] = useState("");
    const [confirmpasswordError, setconfirmpasswordError] = useState("");
    //  const [loading, setLoading] = useState(false);

    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleSecond, setIsVisibleSecond] = useState(false);

    const isBot = (fields) => {
        let bool = false;

        for (let x = 0; x < fields.length; x++) {
            if (fields[x]) {
                bool = true;
                break;
            }
        }
        return bool;
    };

    const onChangeEmail = (event) => {
        setEmail(event.target.value);
        if (email == "") {
            setEmailErrorMessage("");
        }
        if (emailError != "" && validations.emailRegex.test(email)) {
            setEmailErrorMessage("");
        }
    };

    const onChangePassword = (event) => {
        setPassword(event.target.value);
        if (password == "") {
            setpasswordError("");
        }
        if (passwordError != "" && validations.passwordRegex.test(password)) {
            setpasswordError("");
        }
    };

    const onChangeConfirmPassword = (event) => {
        setConfirmPassword(event.target.value);
        if (confirmPassword == "") {
            setconfirmpasswordError("");
        }
        if (confirmpasswordError != "" && validations.passwordRegex.test(confirmPassword)) {
            setconfirmpasswordError("");
        }
    };

    const onBlurEmailInput = async (e) => {
        e.preventDefault();
        if (email.trim() == "") {
            setEmailErrorMessage(validations.emailValidation);
        } else if (!validations.emailRegex.test(email)) {
            setEmailErrorMessage(validations.emailRegexValidation);
        } else {
            setErrorMessage("");
            setEmailErrorMessage("");
            const res = await apiCallV2("POST", "check-email", {
                email_address: email,
            });
            if (res.data.status == 200) {
                localStorage.setItem("email", email);
            } else if (res.data.status == 409) {
                setEmailErrorMessage("Email already exists");
            } else {
                setEmailErrorMessage(res.data.message);
            }
        }
    };

    const onClickSignup = async (e) => {
        if (isBot([emailAddress, fullName])) return;

        if (email.trim() == "") {
            setEmailErrorMessage(validations.emailValidation);
        } else if (!validations.emailRegex.test(email)) {
            setEmailErrorMessage(validations.emailRegexValidation);
        } else if (password == "") {
            setpasswordError(validations.passwordValidation);
        } else if (confirmPassword == "") {
            setconfirmpasswordError(validations.passwordValidation);
        } else if (!validations.passwordRegex.test(password)) {
            setpasswordError(validations.passwordRegexValidation);
        } else if (confirmPassword != "" && password !== confirmPassword) {
            setconfirmpasswordError(validations.passwordMatchValidation);
        } else {
            setErrorMessage("");
            setpasswordError("");
            setEmailErrorMessage("");
            setconfirmpasswordError("");

            const irclickid = localStorage.getItem("irclickid");

            const res = await apiCallV2("POST", "signup", {
                email_address: email,
                user_type: 2, //1 is customer,0 is admin
                password: password,
                emailAddress: emailAddress,
                fullName: fullName,
            });

            if (res.data.status == 200) {
                props.SetUserDetails({
                    email_address: email,
                });

                if (irclickid) {
                    props.CallImpactConversion(irclickid, res.data.data.access_token, email);
                }

                localStorage.setItem("access-token", res.data.data.access_token);
                localStorage.setItem("requirement_status", 0);

                navigate("/user-onboarding");
                return true;
            } else {
                setErrorMessage(res.data.message);
                return false;
            }
        }
    };

    return (
        <>
            <div>
                <form
                    onSubmit={() => {
                        return false;
                    }}
                >
                    {/* ====================== EMAIL (OPEN) ====================== */}
                    {!token && (
                        <div className="form-group">
                            <div className="d-flex align-items-center">
                                <CustomInput
                                    placeholder="EMAIL"
                                    onBlur={(e) => {
                                        onBlurEmailInput(e);
                                    }}
                                    type="text"
                                    className="i-box"
                                    style={{
                                        width: "100%",
                                        borderColor: emailError == "" || emailError == undefined ? "lightgrey" : "red",
                                    }}
                                    value={email}
                                    name="email"
                                    onChange={(event) => onChangeEmail(event)}
                                />
                            </div>
                            {emailError != "" && <p className="error">{emailError}</p>}
                        </div>
                    )}
                    {/* ====================== EMAIL (CLOSE) ====================== */}

                    {/* ====================== PASSWORD (OPEN) ====================== */}
                    <div className="form-group">
                        <div className="d-flex align-items-center">
                            {/* <label>Password</label> */}
                            <div className="position-relative i-box" style={{ width: "100%" }}>
                                <CustomInput
                                    placeholder="PASSWORD"
                                    autoComplete="new-password"
                                    style={{
                                        width: "100%",
                                        borderColor: passwordError == "" ? "lightgrey" : "red",
                                    }}
                                    value={password}
                                    name="password"
                                    onChange={(event) => onChangePassword(event)}
                                    // className="i-box"
                                    type={isVisible ? "text" : "password"}
                                />
                                <button onClick={() => setIsVisible(!isVisible)} type="button" className="btn btn-light icon-right">
                                    {isVisible ? <FillEye /> : <FillEyeSlash />}
                                </button>
                            </div>
                        </div>

                        {passwordError != "" && <p className="error">{passwordError}</p>}
                    </div>
                    {/* ====================== PASSWORD (CLOSE) ====================== */}

                    {/* ====================== CONFIRM PASSWORD (OPEN) ====================== */}
                    <div className="form-group">
                        <div className="d-flex align-items-center">
                            {/* <label>Password</label> */}
                            <div className="position-relative i-box" style={{ width: "100%" }}>
                                <CustomInput
                                    placeholder="CONFIRM PASSWORD"
                                    autoComplete="new-password"
                                    value={confirmPassword}
                                    style={{
                                        borderColor: confirmpasswordError == "" ? "lightgrey" : "red",
                                    }}
                                    name="confirmPassword"
                                    onChange={(event) => onChangeConfirmPassword(event)}
                                    type={isVisibleSecond ? "text" : "password"}
                                />
                                <button onClick={() => setIsVisibleSecond(!isVisibleSecond)} type="button" className="btn btn-light icon-right">
                                    {isVisibleSecond ? <FillEye /> : <FillEyeSlash />}
                                </button>
                            </div>
                        </div>
                        {confirmpasswordError != "" && <p className="error">{confirmpasswordError}</p>}
                    </div>
                    {/* ====================== CONFIRM PASSWORD (CLOSE) ====================== */}

                    {/* ====================== HP (OPEN) ====================== */}
                    <div className="form-group">
                        <div
                            className="d-sm-flex align-items-center" //HONEY-P
                            style={{
                                position: "absolute",
                                top: "-99999px",
                            }}
                        >
                            <label className="text-sm-right drop-m">Email Confirm</label>
                            <CustomInput type="text" value={emailAddress} name="email_confirm" onChange={(event) => setEmailAddress(event.target.value)} className="i-box" />
                        </div>

                        <div
                            className="d-sm-flex align-items-center" //HONEY-P
                            style={{
                                position: "absolute",
                                top: "-99999px",
                            }}
                        >
                            <label className="text-sm-right drop-m">Full Name</label>
                            <CustomInput type="text" value={fullName} name="full_name" onChange={(event) => setFullName(event.target.value)} className="i-box" />
                        </div>
                    </div>
                    {/* ====================== HP (CLOSE) ====================== */}

                    <div className="text-center" style={{ margin: "5px 0 0 0", padding: "20px 0 0 0" }}>
                        <CustomActionButton
                            disabled={error || emailError}
                            action={async () => {
                                return await onClickSignup();
                            }}
                            type={2}
                        >
                            Continue
                        </CustomActionButton>
                    </div>
                </form>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    CallImpactConversion,
    SetUserDetails,
})(EmailSignupComponent);
